/**
 * HTTP client 薄封装（00 开发文档「通用 API 约定」）。
 * - 统一错误解析：{ error: { code, message, fields? } } → ApiError
 * - 分页/双语回退元数据类型来自 contracts
 * 后续 TanStack Query 在此之上封装 hooks（M1 待办）。
 */
import type { ErrorBody } from '@chronospeak/contracts';

const API_BASE = '/api/v1';

export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly fields?: Record<string, string>;

  constructor(status: number, body: ErrorBody['error']) {
    super(body.message);
    this.name = 'ApiError';
    this.status = status;
    this.code = body.code;
    this.fields = body.fields;
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: { Accept: 'application/json', ...init?.headers },
  });
  if (!res.ok) {
    let body: ErrorBody | null = null;
    try {
      body = (await res.json()) as ErrorBody;
    } catch {
      // 非 JSON 错误体（网关层等）
    }
    throw new ApiError(
      res.status,
      body?.error ?? { code: 'INTERNAL_ERROR', message: `请求失败（${res.status}）` },
    );
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export const http = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body: unknown) =>
    request<T>(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }),
};

export { API_BASE };
